// This is the single visibility policy used by both live Vuex inserts and
// history reconciliation. Command side effects still belong to the WS path.
const CUSTOMER_COMMAND_MESSAGE_TYPE = 7;
const CUSTOMER_BEFORE_ENTER_MESSAGE_TYPE = 10;
const CUSTOMER_COMMANDS_FORMATTED_AS_TEXT = Object.freeze([8, 9]);
export const CUSTOMER_VISIBLE_COMMAND_TYPES = Object.freeze([
  1, // match
  2, // transfer
  6, // invite review
  7, // kick
  8, // welcome
  10, // disconnect
  14, // customer close
  20, // agent close
  25, // conversation accepted
  28 // order confirmation
]);

export const isCustomerVisibleMessage = message =>
  Boolean(
    message &&
      (message.type != CUSTOMER_COMMAND_MESSAGE_TYPE ||
        (message.type === CUSTOMER_COMMAND_MESSAGE_TYPE &&
          CUSTOMER_VISIBLE_COMMAND_TYPES.includes(message.commandType)))
  );

// History does not replay command side effects, and the before-enter record is
// a local UI placeholder. Neither is a valid anchor for REST history coverage.
export const isCustomerHistoryCoverageMessage = message =>
  Boolean(
    message &&
      message.type != CUSTOMER_COMMAND_MESSAGE_TYPE &&
      message.type != CUSTOMER_BEFORE_ENTER_MESSAGE_TYPE &&
      !CUSTOMER_COMMANDS_FORMATTED_AS_TEXT.includes(Number(message.commandType))
  );

// A positive server sort is still a valid stopping coordinate even when the
// history API does not replay that command. Only the local before-enter row can
// never anchor server history.
export const isCustomerHistoryAnchorCandidate = message =>
  Boolean(message && message.type != CUSTOMER_BEFORE_ENTER_MESSAGE_TYPE);
